import React from 'react';
import { useSelector } from 'react-redux';
import { liveTrackinglayoutSelector } from '../features/layout/layoutSlice';

import EventListView from '../components/vehicleEvents/EventListView';
import EventBarTop from '../components/vehicleEvents/EventBarTop';
import EventBarPaginate from '../components/vehicleEvents/EventBarPaginate';

const EventView = () => {
    const dimentions = useSelector(liveTrackinglayoutSelector);
    return (
        <div style={dimentions.sidebar}>
            <div style={dimentions.eventBarTop}>
                <EventBarTop />
            </div>
            <div style={{ ...dimentions.eventBarBottom, overflow: 'auto' }}>
                <EventListView />
            </div>
            <div style={dimentions.eventBarPaginate}>
                <EventBarPaginate />
            </div>

        </div>
    );
}

export default EventView;